import type { MediaImage } from '@shared-types/editorial.types';
import type { BaseContentItem, PlaylistItem, UefatvEditorialContent, VodItem } from '@shared-types/uefatv.types';
import { stripHtml } from '@utilities/dom';

export const getImage = (mediaItem: PlaylistItem | VodItem | BaseContentItem): MediaImage => {
  const figure = mediaItem;

  const photo: MediaImage = {
    id: figure.id.toString(),
    description: figure.description,
    title: figure.title,
    image: {},
  };
  photo.image.wide = { w1: figure.thumbnailUrl };

  switch (mediaItem.type) {
    case 'VOD': {
      const item = figure as VodItem;
      photo.image.wide = { w1: item.thumbnailUrl };
      photo.image.square = { s1: item.thumbnailUrl };
      photo.image.portrait = { p1: item.posterUrl ?? item.thumbnailUrl };
      break;
    }
    case 'PLAYLIST': {
      const item = figure as PlaylistItem;
      photo.image.wide = { w1: item.smallCoverUrl ?? item.coverUrl };
      photo.image.square = { s1: item.smallCoverUrl ?? item.coverUrl };
      photo.image.portrait = { p1: item.smallCoverUrl ?? item.coverUrl };
      break;
    }
  }
  return photo;
};

export const mapEditorialContent = (
  data: PlaylistItem | VodItem | BaseContentItem,
  lastSeen?: string,
): UefatvEditorialContent => {
  if (!data) return {};

  const type = data.type;
  const headline = data.title;

  const summary = data.description;
  const mainMedia = getImage(data);
  const photos: MediaImage[] = [mainMedia];
  const body: Record<string, any>[] = [{ TEXT: data.description }];
  const accessLevel = data.accessLevel;
  const vodCount = type === 'PLAYLIST' ? (data as PlaylistItem).vodCount : 0;

  return {
    id: data.id.toString(),
    type,
    title: stripHtml(headline),
    headline,
    htmlDescription: summary,
    description: stripHtml(summary),
    body,
    imageUrl: data.thumbnailUrl,
    mainMedia,
    photos,
    duration: 'duration' in data ? data.duration : undefined,
    document,
    accessLevel,
    vodCount,
    lastSeen,
  };
};
